import React, {useEffect} from 'react'

import {useDispatch} from 'react-redux'

import {useLanguageRouter} from './Components/Hooks/useLanguageRouter'
import Route from './Routes'
import './assets/scss/themes.scss'
import {setupAuthenticatedSession} from './infra/utils/setupAuthenticatedSession'

function App() {
  const dispatch = useDispatch()
  const authToken = localStorage.getItem('authToken')
  const updateLanguageInUrl = useLanguageRouter()

  useEffect(() => {
    setupAuthenticatedSession(authToken, dispatch)
  }, [authToken, dispatch])

  useEffect(() => {
    updateLanguageInUrl()
  }, [updateLanguageInUrl])

  return (
    <React.Fragment>
      <Route />
    </React.Fragment>
  )
}

export default App
